import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestSignOut } from "application/auth/authActions";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

export const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestSignOut());
  }, []);

  return <Loader />;
};
